import { useState } from 'react';
import { getLayerScreensDisclaimerInfo } from 'src/features/locations/scheduleComponentPage/ScheduleComponentPage.helper';
import {
  IDefaultSection,
  IGridSection,
  IPositionGridLines,
  TScreensGridSections,
} from 'src/features/locations/scheduleComponentPage/ScheduleComponentPage.interface';
import { ILayout } from 'src/interfaces';

export const useManagePositionSidebar = (
  layout: ILayout | undefined,
  setScreensGridSections: React.Dispatch<
    React.SetStateAction<TScreensGridSections>
  >,
) => {
  const [screenIndex, setScreenIndex] = useState(0); // will start from 0
  const [layerIndex, setLayerIndex] = useState(-1); // will start from 1
  const [sectionIndex, setSectionIndex] = useState(0); // will start from 0
  const [previewingPositionIndex, setPreviewingPositionIndex] = useState(-1); // will start from 1
  const [showSectionDetailDrawer, setShowSectionDetailDrawer] = useState(false);

  const onUpdateScreensGridSectionsWhenSectionChanges = (
    section: IGridSection | IDefaultSection,
  ) => {
    setScreensGridSections((prev) => {
      const screens = prev[layerIndex][screenIndex];

      const sectionIndex = screens.findIndex((item) => item.i === section.i);

      const updatedScreens = screens.map((item, index) =>
        index === sectionIndex ? section : item,
      );

      return {
        ...prev,
        [layerIndex]: {
          ...prev[layerIndex],
          [screenIndex]: updatedScreens,
        },
      };
    });
  };

  const onUpdateScreensGridSectionsWhenAddingNewPosition = (
    newPosition: IPositionGridLines,
  ) => {
    setScreensGridSections((prev) => ({
      ...prev,
      [newPosition.position]: getLayerScreensDisclaimerInfo(
        newPosition.gridLines,
        (layout as ILayout).screens.map(({ id }) => id),
      ),
    }));
  };

  return {
    screenIndex,
    layerIndex,
    sectionIndex,
    previewingPositionIndex,
    showSectionDetailDrawer,
    setScreenIndex,
    setLayerIndex,
    setSectionIndex,
    setPreviewingPositionIndex,
    setShowSectionDetailDrawer,
    onUpdateScreensGridSectionsWhenSectionChanges,
    onUpdateScreensGridSectionsWhenAddingNewPosition,
  };
};
